import { Signup } from '@/features/auth/Signup';
import { ensureSession } from '@/lib/session';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/signup')({
  staticData: { public: true },
  validateSearch: z.object({ invitation: z.string().optional() }),
  // A session opening /signup goes to / (merchant screens §3.1 Sign up).
  beforeLoad: async ({ context }) => {
    if (await ensureSession(context)) throw redirect({ to: '/' });
  },
  component: Signup,
});
